import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://4912821c4f6ee8223e0c2af69cc5d912@o4504017828315136.ingest.us.sentry.io/4508405941207040",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});
import { init } from 'astro/virtual-modules/prefetch.js';init()